/** 英语 */
import lang from './lang/mk';

export default {
  ...lang,
  ele: {
    tabs: {
      reload: 'Освежи',
      fullscreen: 'Цел екран',
      fullscreenExit: 'Цел екран',
      closeLeft: 'Затвори лево',
      closeRight: 'Затвори десно',
      closeOther: 'Затвори Друго',
      closeAll: 'Затвори ги сите'
    },
    setting: {
      title: 'Поставување на тема',
      sideStyles: {
        dark: 'Темна странична лента',
        light: 'Светла странична лента'
      },
      headStyles: {
        light: 'Светлосен заглавие',
        dark: 'Темно заглавие',
        primary: 'Примарен заглавие'
      },
      layoutStyles: {
        side: 'Распоред на страничното мени',
        top: 'Распоред на горното мени',
        mix: 'Распоред на мешано мени'
      },
      colors: {
        default: 'Сина боја на зората',
        dust: 'Прашливо сина',
        sunset: 'Портокалова боја на зајдисонце',
        volcano: 'Вулкан',
        purple: 'Златно виолетова',
        cyan: 'Цијан',
        green: 'Поларно зелена',
        geekblue: 'Гик Блу'
      },
      darkMode: 'Темен режим',
      layoutStyle: 'Режим на навигација',
      sideMenuStyle: 'Двојно мени на страничната лента',
      bodyFull: 'Цел екран на телото',
      other: 'Друго поставување',
      fixedHeader: 'Фиксен заглавие',
      fixedSidebar: 'Фиксна странична лента',
      fixedBody: 'Фиксирано тело',
      logoAutoSize: 'Адаптација на лого',
      colorfulIcon: 'Шарена икона',
      sideUniqueOpen: 'Отворено уникатно мени',
      weakMode: 'Слаб режим',
      showFooter: 'Прикажи подножје',
      showTabs: 'Прикажи картички',
      tabStyle: 'Стил на табулатор',
      tabStyles: {
        default: 'Стандардно',
        dot: 'Точка',
        card: 'Картичка'
      },
      tips: 'Ќе ја запомни вашата конфигурација следниот пат кога ќе го отворите.'
    },
    tableTools: {
      refresh: 'Освежи',
      size: 'Густина',
      sizeOption: {
        large: 'Лесно',
        medium: 'Стандардно',
        small: 'Секундарно',
        mini: 'Компактен'
      },
      columns: 'Колони',
      columnsOption: {
        columns: 'Колони',
        reset: 'Ресетирај',
        index: 'Броеви',
        selection: 'Избор',
        untitled: 'Без наслов'
      },
      fullscreen: 'Цел екран'
    },
    fileList: {
      selectAll: 'Избери ги сите',
      selectTips: 'Избрана {вкупно} датотека/директориум',
      fileName: 'Име',
      fileSize: 'Големина',
      fileTimestamp: 'Последно изменето'
    },
    cropper: {
      zoomIn: 'Зголеми',
      zoomOut: 'Одзумирање',
      rotateLeft: 'Ротирајлево',
      rotateRight: 'Ротирајнадесно',
      moveLeft: 'Поместилево',
      moveRight: 'Поместинадесно',
      moveUp: 'MoveUp',
      moveDown: 'Помести надолу',
      flipX: 'ФлипИкс',
      flipY: 'FlipY',
      reset: 'Ресетирај',
      upload: 'Постави',
      ok: 'Во ред',
      title: 'Кропер'
    },
    map: {
      title: 'Адреса',
      placeholder: 'Внесете клучен збор',
      message: 'Изберете адреса',
      ok: 'Во ред'
    }
  }
};
